import { render, staticRenderFns } from "./OrdersListTableL.vue?vue&type=template&id=2adcaad6&scoped=true"
import script from "./OrdersListTableL.vue?vue&type=script&lang=js"
export * from "./OrdersListTableL.vue?vue&type=script&lang=js"
import style0 from "./OrdersListTableL.vue?vue&type=style&index=0&id=2adcaad6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adcaad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adcaad6')) {
      api.createRecord('2adcaad6', component.options)
    } else {
      api.reload('2adcaad6', component.options)
    }
    module.hot.accept("./OrdersListTableL.vue?vue&type=template&id=2adcaad6&scoped=true", function () {
      api.rerender('2adcaad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/OrdersListTableL.vue"
export default component.exports